import axios from "../axios";
import { handleFileDownload } from "../../utils";

const api = {
  getSuppliersEmissionsReports(params, accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/suppliers/reports?${params}`, config).then(({ data }) => data);
  },

  getTopTenSuppliersReports({ params }, accessToken) {
    const config = {
      params: params,
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/suppliers/reports/top10`, config).then(({ data }) => data);
  },

  getSupplierSpecificReport({ params }, accessToken) {
    const config = {
      params: params,
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/suppliers/reports/supplier-specific`, config).then(({ data }) => data);
  },

  getUserSpecificSupplier(accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/suppliers/user-specific`, config).then(({ data }) => data);
  },

  getSupplierTiersEmissions({ params }, accessToken) {
    const config = {
      params: params,
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/suppliers/reports/tiers`, config).then(({ data }) => data);
  },

  getSpecificSupplierEmissions({ supplierId, year }, accessToken) {
    const config = {
      params: { year },
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/suppliers/${supplierId}/reports`, config).then(({ data }) => data);
  },

  getSuppliersYearByYearData(params, accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/suppliers/reports/last-three-years-growth?${params}`, config).then(({ data }) => data);
  },

  getSupplierYearlyData(params, accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/suppliers/reports/yearly-emission?${params}`, config).then(({ data }) => data);
  },

  getSuppliersYearByYearAverageData(params, accessToken) {
    const config = {
      params,
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/suppliers/reports/last-three-years-avg-growth`, config).then(({ data }) => data);
  },

  exportTotalEmissions(params, accessToken) {
    const config = {
      params: params,
      responseType: "arraybuffer",
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get("/suppliers/total-emissions/export", config).then(({ data, headers }) => {
      handleFileDownload(data, headers, "Total_emissions_export");
    });
  },

  updateReportExclusion(data, accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.post("/suppliers/reports/exclude", data, headers).then(({ data }) => data);
  },

  exportYearByYearData(accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get("/suppliers/last-three-years-growth/export", config).then(({ data, headers }) => {
      handleFileDownload(data, headers, "Year_by_year_data_export");
    });
  },
};

export default api;
